import styled from '@emotion/styled';
import { format } from 'date-fns';
import { useState } from 'react';
import { Css, ITheme, RefreshIcon, Responsive, TextButton } from '../../../ui';

interface IRefreshData {
	refetch: () => void | Promise<unknown>;
	label: string;
	lastUpdatedAt?: Date | null;
}

export default function RefreshData({
	refetch,
	label,
	lastUpdatedAt,
}: IRefreshData) {
	const [lastManualRefreshTime, setLastManualRefreshTime] =
		useState<Date | null>(null);
	const displayedUpdatedTime = lastUpdatedAt ?? lastManualRefreshTime;
	const formattedTime = displayedUpdatedTime
		? format(displayedUpdatedTime, 'hh:mm a')
		: null;

	const onClickRefresh = () => {
		refetch();
		setLastManualRefreshTime(new Date());
	};

	return (
		<RefreshDataWrap>
			{formattedTime && <div>Last updated: {formattedTime}</div>}
			<StyledRefreshButton type="button" onClick={onClickRefresh}>
				{label} <RefreshIcon aria-hidden />
			</StyledRefreshButton>
		</RefreshDataWrap>
	);
}

const RefreshDataWrap = styled.div`
	grid-column: span 2;
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: ${Css.pxToRem(16)};
	margin-top: ${Css.pxToRem(23)};
	margin-bottom: ${Css.pxToRem(72)};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		align-items: flex-start;
		gap: ${Css.pxToRem(4)};
		margin-top: ${Css.pxToRem(15)};
		margin-bottom: ${Css.pxToRem(40)};
	}
`;

const StyledRefreshButton = styled(TextButton)<{}, ITheme>`
	cursor: pointer;
	color: ${(props) => props.theme.color.secondary};
	font-size: ${Css.pxToRem(16)};
	font-weight: 700;
	padding: 0;

	&:hover {
		color: ${(props) => props.theme.button.textButton.hover.font.color};
	}

	svg {
		path {
			fill: currentColor;
		}
	}
`;
